import loadable from '@loadable/component';

export const EditOrgPageContainerLoadable = loadable(
  () => import('./EditOrgPage'),
  {
    resolveComponent: (module) => module.EditOrgPage,
  },
);
